var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSui = function SvgSui(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4DA2FF",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.304 10.836a4.172 4.172 0 0 1-.026 5.254l-.051.062-.015-.08c-.011-.066-.026-.135-.04-.205-.294-1.288-1.254-2.395-2.838-3.293-1.067-.602-1.68-1.329-1.841-2.154-.103-.533-.026-1.07.121-1.53.15-.46.37-.843.557-1.073l.616-.749a.27.27 0 0 1 .418 0l3.099 3.768Zm.971-.748L12.154 5.07a.198.198 0 0 0-.304 0l-4.125 5.017-.015.018a5.444 5.444 0 0 0-1.21 3.425C6.5 16.55 8.964 19 12 19s5.5-2.45 5.5-5.47a5.426 5.426 0 0 0-1.214-3.424l-.01-.018Zm-7.564.734.367-.45.01.085c.008.065.019.131.034.197.238 1.245 1.092 2.285 2.515 3.088 1.24.701 1.958 1.508 2.167 2.396.088.368.103.733.066 1.051l-.004.018-.018.008a4.242 4.242 0 0 1-1.852.423c-2.328 0-4.216-1.877-4.216-4.191 0-.993.348-1.91.931-2.625Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSui);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sui.eade4ebe35cf53ff34fbdd1800307afd.svg";